<template>
  <div id="select" @mouseleave="handleMouseOut">
    <div style="position:relative;height:inherit" @click="handleShow">
      <input type="text" :placeholder="placeholder" readonly class="searchInp" v-model="val">
      <span class="sanjiao"></span>
    </div>
    <ul class="opt" :style="opstyle" v-show="isOpShow" @click="handleSelect"  >
      <li v-for="item in options" :key="item.code" :code="item.code">{{item.val}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data(){
    return{
      isOpShow:false,
      selectShow:false,
      val:"",
      code:'',
      n:0,
    }
  },
   methods:{
     handleShow(){
       this.n++;
       if(this.n%2 === 1){
         this.isOpShow = true;
       }else{
         this.isOpShow = false;
       }
     },
     handleSelect(){
       let event = event || window.event
       let target = event.target;
       if(target.nodeName.toLowerCase() === 'li'){
        this.code = target.getAttribute('code')
        this.val = target.innerHTML
        this.$emit('getDay',this.code)
       }
       this.isOpShow = false;
     },
     handleMouseOut(){
       this.isOpShow = false;
       this.n = 0;
     }
  },
  props:{
    placeholder:String,
    options:Array,
    opstyle:Object,
    pstyle:String
  },

}
</script>

<style lang="less">
  #select{
    cursor: pointer;
    width: 300px;
    border: 1px solid #a0a0a0;
    position: relative;
    min-height: 35px;
    z-index: 99;
    .searchInp{
      position: absolute;
      height: 33px;
      text-indent: 5px;
      cursor: pointer;
      width: 298px;
    }
    .sanjiao{
      width:0px;
      border: 6px solid transparent;
      border-top-color: #ccc;
      position: absolute;
      top: 12px;
      right: 5px;
    }

    .opt{
      margin-top: -1px;
      background-color: #fff;
      width: 300px;
      margin-left: -1px;
      box-shadow: 0px 2px 5px 1px #c9c9c9;
      // z-index: 9999;
      position: absolute;
      top: 35px;

    }
    .opt li{
      line-height: 34px;
      border: 1px solid #ccc;
      z-index: 99;
      text-indent: 5px;
      &:hover{
        background-color: #eaeaea;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mselect/MSelect.vue